import React, { useRef, useState } from 'react'
import BillDetail from '../Modal/BillDetail'
import DateFormat from './DateFormat'
import axios from 'axios';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import DiscountSummaryChart from './DiscountSummaryChart';

const DiscountOrderTable = ({ discountOrders, selectedOutlet, token, url, error, loading }) => {
    const [billInfo, setBillInfo] = useState({});
    const [billInfoList, setBillInfoList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const tableRef = useRef(null);

    const handleBillInfo = async (bill, date) => {
        try {
            const convertDate = new Date(date).toISOString().substring(0, 10);

            const { data } = await axios.post(`${url}/billinfo`, {
                bill_no: bill,
                Date: convertDate,
                Outlet_Name: selectedOutlet,
                token: token,
            });

            if (data) {
                setBillInfoList(data.details || []);
                setBillInfo(data);
                setShowModal(true);
            }
        } catch (error) {
            console.log("Bill error", error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const orders = (discountOrders?.selected_discount_orders || []).slice().sort((a, b) => {
        const dateA = new Date(a.order_info?.Date);
        const dateB = new Date(b.order_info?.Date);
        return dateB - dateA; 
    });


    const totalDiscount = orders.reduce((sum, order) => {
        return sum + parseFloat(order.order_info?.DiscountAmt || 0);
    }, 0);

    const grandTotal = orders.reduce((sum, order) => {
        return sum + parseFloat(order.order_info?.Total || 0);
    }, 0);

    if (loading) {
        return (
            <div className="flex justify-center my-5 max-w-2xl mx-auto">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return <div className="alert alert-danger my-5 max-w-2xl mx-auto">Error loading discount orders: {error.error}</div>;
    }

    return (
        <>
            <div className="table-customer-history">
                <DownloadTableExcel
                    filename="discount_orders"
                    sheet="discounthistory"
                    currentTableRef={tableRef.current}>
                    <button className="export">
                        Export
                    </button>
                </DownloadTableExcel>

                <div className="table-history-responsive table-data-customer mt-2">
                    <table className="table-customer" ref={tableRef}>
                        <thead>
                            <tr className='position-sticky'>
                                <th>Bill No.</th>
                                <th>Customer</th>
                                <th>Date</th>
                                <th>Discount Amount</th>
                                <th>Discount Type</th>
                                <th>Total</th>
                                <th>Employee</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.length > 0 ? (
                                orders.map((order, index) => {
                                    const orderInfo = order.order_info || {};
                                    return (
                                        <tr key={`${orderInfo.bill_no}-${index}`}>
                                            <td>
                                                <button
                                                    type="button"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                    onClick={() => handleBillInfo(orderInfo.bill_no, orderInfo.Date)}
                                                    className="btn btn-link p-0"
                                                >
                                                    {orderInfo.bill_no}
                                                </button>
                                            </td>
                                            <td>{orderInfo.GuestName || 'N/A'}</td>
                                            <td>
                                                <DateFormat date={orderInfo.Date} />
                                            </td>
                                            <td>{orderInfo.DiscountAmt || '0.00'}</td>
                                            <td>{orderInfo.Discounts || 'N/A'}</td>
                                            <td>{orderInfo.Total || '0.00'}</td>
                                            <td>{orderInfo.Employee || 'N/A'}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">No discount orders found</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="3"></td>
                                <td className="fw-bold">Total Discount: {totalDiscount.toFixed(2)}</td>
                                <td></td>
                                <td className="fw-bold">Grand Total: {grandTotal.toFixed(2)}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <DiscountSummaryChart discountSummary={discountOrders?.discount_summary || []} />

                <BillDetail
                    showModal={showModal}
                    handleCloseModal={handleCloseModal}
                    billInfo={billInfo}
                    billInfoList={billInfoList}
                    selected={selectedOutlet}
                />
            </div>
        </>
    )
}

export default DiscountOrderTable
